import { useToast } from '../../../context/ToastContext';
import { numericProps } from '../../../utils/numericInput';

function calcEpley1RM(reps, weight) {
    const r = +reps, w = +weight;
    if (!r || !w || r > 30 || r < 1) return null;
    return Math.round(w * (1 + r / 30));
}

export default function SetsEditor({ sets, onChange }) {
    const showToast = useToast();
    const update = (i, key, val) => onChange(sets.map((s, idx) => idx === i ? { ...s, [key]: val } : s));
    const add = () => {
        const last = sets[sets.length - 1];
        onChange([...sets, { reps: last?.reps || '', weight: last?.weight || '' }]);
    };
    const remove = i => onChange(sets.filter((_, idx) => idx !== i));

    const bestIdx = sets.reduce((best, s, i) => {
        const curr = calcEpley1RM(s.reps, s.weight);
        const bestVal = best !== null ? calcEpley1RM(sets[best].reps, sets[best].weight) : null;
        if (curr === null) return best;
        if (bestVal === null || curr > bestVal) return i;
        return best;
    }, null);

    return (
        <>
            {sets.map((s, i) => {
                const est1RM = calcEpley1RM(s.reps, s.weight);
                const isBest = i === bestIdx && est1RM !== null && sets.length > 1;
                return (
                    <div key={i} className="set-row">
                        <span className="set-num">{i + 1}</span>
                        <input className="form-input" style={{ padding: 8 }} placeholder="횟수"
                            {...numericProps(s.reps, v => update(i, 'reps', v), showToast)} />
                        <input className="form-input" style={{ padding: 8 }} placeholder="무게(kg)"
                            {...numericProps(s.weight, v => update(i, 'weight', v), showToast, { allowDecimal: true })} />
                        {est1RM ? (
                            <span style={{ fontSize: 10, color: isBest ? 'var(--accent)' : 'var(--text3)', minWidth: 48, textAlign: 'right', lineHeight: 1.3 }}>
                                {isBest ? '★' : '≈'}{est1RM}
                            </span>
                        ) : <span style={{ width: 48 }} />}
                        {i > 0
                            ? <button className="remove-btn" onClick={() => remove(i)}>×</button>
                            : <span style={{ width: 20 }} />}
                    </div>
                );
            })}
            <button className="add-set-btn" onClick={add}>+ 세트 추가</button>
        </>
    );
}
